(function (window) {
  /**
   * Opens a tooltip at a given LatLng. Under the hood it extends the
   * google.maps.OverlayView class to draw it.
   *
   * @example
   * var tooltip = new BatchGeoMapTooltip({
   *   map: window.batchGeoGoogleMapsManager.getMap(),
   *   position: someMarker.position,
   *   title: "Hello World",
   *   text: "This would be a description or something"
   * });
   *
   * @param {object} options An options hash (see below for specific options
   * and what they do).
   *   @param {google.maps.Map} options.map A Gmaps Map instance to put the tooltip on
   *   @param {google.maps.LatLngBounds} options.position A LatLngBounds instance with the
   *   positioning you want for the tooltip
   *   @param {string} options.title The title of the tooltip
   *   @param {string} options.text The text below the title of the tooltip
   *
   * @extends {google.maps.OverlayView}
   * @constructor
   */
  BatchGeoMapTooltip = function (options) {
    this.settings = _.merge(
      {},
      {
        map: null,
        position: null,
        title: "",
        text: "",
      },
      options,
    );

    this.$anchor = $("<div />", {
      class: this.settings.title
        ? "batchgeo-map-tooltip-anchor"
        : "batchgeo-map-tooltip-anchor no-title",
      html: [
        $("<div />", {
          class: "batchgeo-map-tooltip-content",
          html: [
            this.settings.title && $("<h1 />", { text: this.settings.title }),
            $("<p />", { text: this.settings.text }),
          ],
        }),
      ],
    });
  };

  // Extend the google.maps.OverlayView class so we can draw on the map with
  // our own API. The important required methods we get from this are draw,
  // onAdd, and onRemove.
  BatchGeoMapTooltip.prototype = Object.create(
    google.maps.OverlayView.prototype,
  );

  /**
   * Will show the tooltip
   */
  BatchGeoMapTooltip.prototype.init = function () {
    // We don't want this popping up on mobile since you can't hover but it
    // will open for a split second on taps sometimes
    if (BatchGeoDevices.is("mobile")) return;
    this.setMap(this.settings.map);
  };

  /**
   * Removes the tooltip from the map
   */
  BatchGeoMapTooltip.prototype.destroy = function () {
    this.setMap(null);
  };

  /**
   * This is called by the Google Maps JS API when you call setMap which we do
   * inside of init.
   *
   * IMPORTANT: Do not delete this method, even if it is empty
   */
  BatchGeoMapTooltip.prototype.draw = function () {
    var divPosition = this.getProjection().fromLatLngToDivPixel(
      this.settings.position,
    );
    this.$anchor.css({
      left: divPosition.x + "px",
      top: divPosition.y + "px",
    });
  };

  /**
   * This is called by the Google Maps JS API when you call setMap which we do
   * inside of init.
   *
   * IMPORTANT: Do not delete this method, even if it is empty
   */
  BatchGeoMapTooltip.prototype.onAdd = function () {
    $(this.getPanes().floatPane).append(this.$anchor);
  };

  /**
   * This is called by the Google Maps JS API when you call setMap(null) which
   * we do inside of destroy.
   *
   * IMPORTANT: Do not delete this method, even if it is empty
   */
  BatchGeoMapTooltip.prototype.onRemove = function () {
    this.$anchor.remove();
  };

  window.BatchGeoMapTooltip = BatchGeoMapTooltip;
})(window);
